import { faChevronRight } from "@fortawesome/pro-solid-svg-icons/faChevronRight";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC, ReactNode } from "react";

import styles from "./AuthTypeButton.module.css";

type Props = {
  logo: ReactNode;
  title: string;
  description: string;
  onAuthRequestClick: () => void;
};

const AuthTypeButton: FC<Props> = ({
  onAuthRequestClick,
  logo,
  title,
  description,
}) => (
  <button
    type="button"
    className={styles.button}
    onClick={onAuthRequestClick}
    data-testid="auth-type-button"
  >
    <div aria-hidden={true}>{logo}</div>
    <div className={styles.textContent}>
      <p className={styles.title}>{title}</p>
      <p>{description}</p>
    </div>
    <div className={styles.chevronWrapper}>
      <FontAwesomeIcon
        icon={faChevronRight}
        style={{ width: 20, height: 20 }}
      />
    </div>
  </button>
);

export default AuthTypeButton;
